export const REISSUED_ANSWER_ID = 6;
export const DEFAULT_QUESTION_ID = 1;
